export default __webpack_public_path__ + "static/media/gil.336d7645.jpg";